import React from "react";
import CardLayout from "../../../../../components/layouts/CardLayout";
import MiniFadedChart from "../../../../../components/icons/MiniFadedChartIcon";
import ReactMarkdown from "react-markdown";
import { Text } from "../../../../../modules/Dashboard";

// ======================
// Section color theme
// ======================
const sectionStyles = {
    KEY_LIQUIDITY_LEVELS: {
        titleColor: "text-yellow-400",
        cardClass: "border-yellow-500",
    },
    MarketMaker_VIEW: {
        titleColor: "text-teal-400",
        cardClass: "border-teal-500",
    },
    TRADERS: {
        titleColor: "text-emerald-400",
        cardClass: "border-emerald-500",
    },
    LIQUIDITY_SUMMARY: {
        titleColor: "text-cyan-400",
        cardClass: "border-cyan-500",
    },
};

// ======================
// Helpers
// ======================
const isPrimitive = (val) =>
    typeof val === "string" || typeof val === "number";

const isPlainObject = (val) =>
    typeof val === "object" && val !== null && !Array.isArray(val);

// Recursive renderer for nested objects
const RenderObject = ({ data }) => {
    return (
        <div className="grid grid-cols-1 gap-3">
            {Object.entries(data).map(([key, value], idx) => (
                <div
                    key={idx}
                    className="rounded-xl p-3 bg-[#1E222A] flex flex-col gap-2"
                >
                    <Text
                        tid={key}
                        className="!text-mainColor font-semibold text-sm"
                    />

                    {isPrimitive(value) && (
                        <Text tid={String(value)} className="text-sm text-white/80" />
                    )}

                    {isPlainObject(value) && (
                        <div className="pl-3 border-l border-white/10">
                            <RenderObject data={value} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

// ======================
// Main Component
// ======================
const HeatMapGPT5 = ({ advance }) => {
    if (!advance || typeof advance !== "object") return null;

    return (
        <div className="grid grid-cols-1 gap-6">
            {Object.entries(advance).map(([sectionKey, content], idx) => {
                const styles =
                    sectionStyles[sectionKey] || sectionStyles.LIQUIDITY_SUMMARY;

                return (
                    <CardLayout
                        key={idx}
                        className={`flex flex-col gap-4 ${styles.cardClass}`}
                    >
                        <div className="flex items-center gap-2">
                            <MiniFadedChart />
                            <ReactMarkdown
                                children={sectionKey}
                                className={`text-xl font-semibold ${styles.titleColor}`}
                            />
                        </div>

                        {/* Summary / markdown text */}
                        {typeof content === "string" && (
                            <ReactMarkdown className="text-white/80 leading-relaxed">
                                {content}
                            </ReactMarkdown>
                        )}

                        {/* Objects (liquidity levels, MM view, traders) */}
                        {isPlainObject(content) && (
                            <RenderObject data={content} />
                        )}
                    </CardLayout>
                );
            })}
        </div>
    );
};

export default HeatMapGPT5;
